import { render, staticRenderFns } from "./ForgotPasswordSuccess.vue?vue&type=template&id=c89c399a&scoped=true&"
import script from "./ForgotPasswordSuccess.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordSuccess.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPasswordSuccess.vue?vue&type=style&index=0&id=c89c399a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c89c399a",
  null
  
)

export default component.exports